import { Fragment } from "react";

function StandardEmpty({ msg = "Nothing to show" }) {
  return (
    <Fragment>
      <div className="standard-empty-container">
        <div>
          <img
            src={`${process.env.PUBLIC_URL}/images/icons/empty_icon_msg.svg`}
            alt="Message Icon"
          />
        </div>
        <span>{msg}</span>
      </div>
    </Fragment>
  );
}

export default StandardEmpty;
